<template>
  <v-layout column align-end>
    <list-edition-toolbar
      :buttons="toolbarButtons"
      @add="startEditingItem(null, 'create')"
    />

    <checklist-table
      :edition-disabled="editionDisabled"
      :allRows="rowsPerPage"
      :checklist="editedChecklist"
      @editItem="startEditingItem($event, 'edit')"
      @removeItem="tryRemoveItem"
    />

    <checklist-item-edition
      v-if="itemEditionDialog"
      :open="itemEditionDialog"
      :original-item="itemToEdit"
      :item-index="itemIndex"
      :stored-items="originalChecklistItems"
      @close="closeItemEdition"
      @add="addItem"
      @edit="editItem"
    />

    <app-dialog-box
      :open="itemDeleteDialog"
      :title="$t('DeleteItem')"
      :content="$t('DeleteConfirmation') + ' ' + itemToEdit.label + '?'"
      :main-action-label="$t('No')"
      @mainAction="itemDeleteDialog = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="removeItem"
    />
  </v-layout>
</template>

<script>
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import ChecklistItemEdition from "./ChecklistItemEdition";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import ChecklistTable from "@/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/ChecklistTable";

export default {
  name: "ObjectFormTaskDetailsChecklist",

  components: {
    ChecklistTable,
    AppDialogBox,
    ChecklistItemEdition,
    ListEditionToolbar
  },

  props: {
    task: {
      type: Object,
      required: true
    },
    editionDisabled: {
      type: Boolean
    },
    rowsPerPage: {
      type: Array
    },
  },

  data() {
    return {
      itemEditionDialog: false,
      itemDeleteDialog: false,

      editedChecklist: [],
      itemIndex: -1,
      newItem: {
        label: null,
        index: null,
        type: null,
        required: true,
        value: false
      },

      itemToEdit: {}
    };
  },

  computed: {
    toolbarButtons() {
      return [
        {
          id: "add",
          icon: "add_circle",
          tooltip: this.$i18n.t("AddItem"),
          active: true,
          disabled: this.editionDisabled
        }
      ];
    },

    originalChecklistItems() {
      if (this.task.hasOwnProperty("content")) {
        return this.task.content;
      }
      return this.task;
    }
  },

  mounted() {
    this.setUpData();
  },

  methods: {
    setUpData() {
      this.editedChecklist = Array.from(this.originalChecklistItems);
    },

    openEditingDialog() {
      this.itemEditionDialog = true;
    },

    addItem(newItem) {
      this.$emit("addItems", newItem);
    },

    startEditingItem(item, actionType) {
      if (actionType === "edit") {
        this.itemIndex = this.editedChecklist.indexOf(item);
        this.itemToEdit = Object.assign({}, item);
      } else {
        this.itemToEdit = this.newItem;
      }

      this.openEditingDialog();
    },

    editItem(editedItem) {
      this.$emit("editItems", editedItem, this.itemIndex);
      this.editedChecklist.splice(this.itemIndex, 1, editedItem);
    },

    tryRemoveItem(itemToDelete) {
      this.itemToEdit = itemToDelete;
      this.itemDeleteDialog = true;
    },

    removeItem() {
      const index = this.editedChecklist.indexOf(this.itemToEdit);
      this.editedChecklist.splice(index, 1);
      this.$emit("removeItem", index, this.itemToEdit.uuid);
      this.itemToEdit = {};
      this.itemDeleteDialog = false;
    },

    closeItemEdition() {
      this.itemEditionDialog = false;
      this.itemToEdit = {};
      this.itemIndex = -1;
    }
  },

  watch: {
    originalChecklistItems() {
      this.setUpData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/Checklist.vue